<template>
    <div>
        <div class="area">
            <!-- <span>地址:</span> -->
            <el-cascader size="large" ref="city" :options="optionsCity" v-model="district" @change="handleChange">
            </el-cascader>
        </div>
    </div>
</template>
<script>
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
export default {
    props: {
        addressArray: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            optionsCity: regionData,
        }
    },
    computed: {
        district: {
            get() {
                let TextToCodeDev = TextToCode;
                let addressArray = this.addressArray;
                if (addressArray) {
                    addressArray = addressArray.split(',')
                    return TextToCodeDev[addressArray[0]]['code'], TextToCodeDev[addressArray[0]][addressArray[1]]['code'], TextToCodeDev[addressArray[0]][addressArray[1]][addressArray[2]]['code']
                }
            },
            set(v) {
                console.log(v)
            }

        }
    },
    methods: {
        // 省市区
        handleChange(val) {
            let node = this.$refs['city'].getCheckedNodes()[0].pathNodes;
            let arr = []
            node.forEach(item => {
                arr.push(item.label)
            })
            // this.dataEdit.district = arr.join(',')
            this.$emit('getAddress', arr.join(','));
            console.log(arr)
        },
    }
}
</script>
<style lang="less" scoped>
.area {
  display: flex;
  width: 100%;
  align-items: center;
  span {
    display: inline-block;
    width: 100px;
  }
  /deep/ .el-cascader {
    width: 100%;
    // width: calc(100% - 100px);
    // /deep/ .el-input {
    //   width: 130% !important;
    // }
  }
}
</style>
